function setLoad(block) {
  block.querySelector('.timeline .inner').scrollLeft =
    block.querySelector('.timeline .inner .scroll').offsetWidth - block.querySelector('.timeline').offsetWidth;
}

function refresh(block) {
  let inner = block.querySelector('.timeline .inner'),
    scroll = inner.scrollLeft,
    scrollPercentage = (100 * scroll) / (inner.scrollWidth - inner.clientWidth);

  block.querySelector('.slider input').value = scrollPercentage;

  block.querySelector('.slider input').dispatchEvent(
    new Event('input', {
      detail: {
        custom: true
      }
    })
  );
}

document.querySelectorAll('.milestones-block').forEach(block => {
  let inner = block.querySelector('.timeline .inner');

  block.querySelector('.slider input').addEventListener('input', e => {
    if (e.detail && e.detail.custom) {
      return;
    }
    let value = e.target.value;
    if (value > 0) {
      let size = block.querySelector('.timeline .inner .scroll').offsetWidth - block.querySelector('.timeline').offsetWidth;
      if (size > 0) {
        inner.scrollLeft = size * (value / 100);
      }
    }
  });

  inner.addEventListener('resize', e => refresh(block));
  inner.addEventListener('scroll', e => refresh(block));

  document.addEventListener('DOMContentLoaded', e => setLoad(block));
  window.addEventListener('customLoaded', e => setLoad(block));
});
